<template>
  <generic-modal :title="$t('little jar record')" ref="generic_modal">
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("patient") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.patient"
                :placeholder="$t('patient')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("date") }}</label>
            <generic-calendar
              type="date"
              display_mode="dialog"
              ref="date_calendar"
              @selected="date_changed"
            />
          </div>
        </div>
      </div>
      <div class="field">
        <generic-dropdown
          :title="$t('little jar')"
          :placeholder="$t('select one')"
          :is_multiple="false"
          url="/little_jar/catalog"
          name_field="name"
          value_field="little_jar_id"
          @selected="little_jar_changed"
          ref="little_jar_dropdown"
        />
      </div>
      <div class="field">
        <label class="label">{{ $t("symptoms") }}</label>
        <div class="control">
          <textarea
            rows="2"
            class="textarea"
            v-model="meta.symptoms"
          ></textarea>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal, GenericDropdown, GenericCalendar },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      loading: false,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.patient || !v.meta.date;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();
      if (uuid) {
        get("/little_jar/record", { uuid: uuid })
          .then((response) => {
            v.meta = response;
            v.$refs.date_calendar.set_date(response.date);
            v.$refs.little_jar_dropdown.set_value(response.little_jar_id);
          })
          .catch((error) => {
            error_message(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      v.$root.loader(true);
      if (v.meta.uuid) {
        post("/little_jar/record", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.loading = false;
            v.$root.loader(false);
          });
      } else {
        put("/little_jar/record", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          })
          .finally(() => {
            v.loading = false;
            v.$root.loader(false);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.$refs.date_calendar.clear();
      v.$refs.little_jar_dropdown.clear();
      v.error = "";
    },
    little_jar_changed(little_jar) {
      let v = this;
      if (little_jar) v.meta.little_jar_id = little_jar.little_jar_id;
    },
    date_changed(date) {
      let v = this;
      v.meta.date = date;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
